// Amplify v6 format; the region comes from the user pool ID.
export default {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USERPOOL_ID,
      userPoolClientId: import.meta.env.VITE_AWS_USERPOOL_WEBCLIENT_ID,
    },
  },
};
